import { useaxios } from "../../../../utils/useaxios";
export default (from, to) => initDispatch => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('project_expense/read.php', { from, to }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
            initDispatch({ type: 'setexpense', payload: res.expense });
        } else {
            // clear();
        }
        // setloading(false);
    });
}